module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/banners/viewy-rc-900fbe0a24af70b168f05ffd106f6f4f.lottie";